"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preg = exports.Email = exports.Range = exports.Max = exports.Min = exports.FloatNumber = exports.IntegerNumber = exports.Numeric = exports.MaxLength = exports.MinLength = exports.Required = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var isEmpty = function isEmpty(value) {
  return (// Check if undefined
    typeof value === 'undefined' || // Check if null
    value === null || // Check is empty String
    (typeof value === 'string' || value instanceof String) && value === '' || // Check if empty Array
    Array.isArray(value) && value.length === 0 || // Check if empty Object
    _typeof(value) === 'object' && Object.keys(value).length === 0
  );
};

var Required = function Required() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Required';
  return function (value) {
    if (isEmpty(value)) {
      return message;
    }

    return true;
  };
};

exports.Required = Required;

var MinLength = function MinLength(min) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Minimum ".concat(min, " characters");
  return function (value) {
    if (isEmpty(value)) {
      return true;
    }

    if (!(typeof value === 'string' || value instanceof String) || value.toString().length < min) {
      return message;
    }

    return true;
  };
};

exports.MinLength = MinLength;

var MaxLength = function MaxLength(max) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Maximum ".concat(max, " characters");
  return function (value) {
    if (isEmpty(value)) {
      return true;
    }

    if (!(typeof value === 'string' || value instanceof String) || value.toString().length > max) {
      return message;
    }

    return true;
  };
};

exports.MaxLength = MaxLength;

var Numeric = function Numeric() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Not valid number';
  return function (value) {
    if (isEmpty(value)) {
      return true;
    }

    if (!(typeof value === 'string' || value instanceof String || Number(value) === value) || !/^-?\d+(\.\d+)?$/.test(value.toString())) {
      return message;
    }

    return true;
  };
};

exports.Numeric = Numeric;

var IntegerNumber = function IntegerNumber() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Not valid integer number';
  return function (value) {
    if (isEmpty(value)) {
      return true;
    }

    if (!(typeof value === 'string' || value instanceof String || Number(value) === value) || !/^-?\d+$/.test(value.toString())) {
      return message;
    }

    return true;
  };
};

exports.IntegerNumber = IntegerNumber;

var FloatNumber = function FloatNumber() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Not valid float number';
  return function (value) {
    if (isEmpty(value)) {
      return true;
    }

    if (!(typeof value === 'string' || value instanceof String || Number(value) === value) || !/^-?\d+\.\d+$/.test(value.toString())) {
      return message;
    }

    return true;
  };
};

exports.FloatNumber = FloatNumber;

var Min = function Min(min) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Minimum ".concat(min);
  return function (value) {
    if (isEmpty(value)) {
      return true;
    }

    if (!(typeof value === 'string' || value instanceof String || Number(value) === value) || !/^-?\d+(\.\d+)?$/.test(value.toString()) || parseFloat(value.toString()) < min) {
      return message;
    }

    return true;
  };
};

exports.Min = Min;

var Max = function Max(max) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Maximum ".concat(max);
  return function (value) {
    if (isEmpty(value)) {
      return true;
    }

    if (!(typeof value === 'string' || value instanceof String || Number(value) === value) || !/^-?\d+(\.\d+)?$/.test(value.toString()) || parseFloat(value.toString()) > max) {
      return message;
    }

    return true;
  };
};

exports.Max = Max;

var Range = function Range(range) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Not valid';
  return function (value) {
    if (isEmpty(value)) {
      return true;
    }

    if (!range.includes(value)) {
      return message;
    }

    return true;
  };
};

exports.Range = Range;

var Email = function Email() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Not valid email address';
  return function (value) {
    if (isEmpty(value)) {
      return true;
    }

    if (!(typeof value === 'string' || value instanceof String) || // RFC 5322
    // eslint-disable-next-line max-len
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value.toString())) {
      return message;
    }

    return true;
  };
};

exports.Email = Email;

var Preg = function Preg(regexp) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Not valid';
  return function (value) {
    if (isEmpty(value)) {
      return true;
    }

    if (!(typeof value === 'string' || value instanceof String) || !regexp.test(value.toString())) {
      return message;
    }

    return true;
  };
};

exports.Preg = Preg;